const accountingEN = {
    "view": {
        "table": {
            "title": "Accounting List",
            "column": {
                "release": "Release",
                "period": "Period",
                "royalties": "Royalties",
                "costs": "Costs",
                "net_revenue": "Net Revenue",
                "status": "Status",
                "accounting_report": "Accounting Report",
                "details": "Details"
            },
            "placeholder": {
                "search": "Search..."
            },
            "button": {
                "statusCreating": "Creating",
                "statusGenerating": "Generating",
                "statusGenerated": "Generated",
                "statusNotGenerated": "Not Generated",
                "open": "Open",
                "downloadPDF": "Download PDF",
                "generatingPDF": "Generating PDF",
                "exportCsv": "Export CSV",
            }
        },
        "message": {
            "subscriptionUpgrade": "Your current subscription plan does not support this feature. Please <1>upgrade</1> your subscription plan to avail this feature.",
            "subscriptionExpired": "Your subscription has expired. Please <1>resume</1> your subscription to avail this feature.",
            "noAccess": "You don't have access to this module, please contact the support team for further information."
        }
    },
    "add": {
        "form": {
            "label": {
                "filters": "Filters",
                "monthRange": "Month Range",
                "release": "Release",
            },
            "options": {
                "allReleases": "All Releases"
            },
            "placeholder": {
                "startingMonth": "Starting Month",
                "endingMonth": "Ending Month"
            },
            "button": {
                "generate": "Generate Accounting Report",
                "reset": "Reset Filters"
            },
            "table": {
                "title": "Earnings available for accounting",
                "columns": {
                    "month": "Month",
                    "year": "Year",
                    "revenue": "Revenue",
                    "status": "Status",
                },
                "label": {
                    "status_open": "Open",
                    "status_accounted": "Accounted",
                    "month_january": "January",
                    "month_february": "February",
                    "month_march": "March",
                    "month_april": "April",
                    "month_may": "May",
                    "month_june": "June",
                    "month_july": "July",
                    "month_august": "August",
                    "month_september": "September",
                    "month_october": "October",
                    "month_november": "November",
                    "month_december": "December"
                },
            }
        },
        "modal": {
            "header": "Add Accounting",
            "body": "Are you sure you want to add new accounting for Release: {{release}}, PERIOD: {{startingMonth}} TO {{endingMonth}} ?"
        },
        "message": {
            "success": "Accounting has been created!",
            "errorSomethingWentWrong": "Something went wrong! Please refresh page and try again!",
            "errorNoEarningsAvailable": "No earnings available for accounting.",
            "errorNoReleaseSelected": "Please select a particular release for accounting."
        }
    },
    "breakdown": {
        "view": {
            "table": {
                "title": "Accounting Breakdown",
                "column": {
                    "revenueShareHolder": "Shareholder",
                    "revenue": "Net Shareholder Royalty",
                    "reportPdf": "Download PDF",
                    "action": "Action",
                    "emailSent": "Email Sent"
                },
                "label": {
                    "downloadPDF": "Download PDF",
                    "generatingPDF": "Generating PDF",
                },
                "button": {
                    "exportCsv": "Export CSV",
                },
                "modal": {
                    "confirm": {
                        "header": "Send Report To Shareholder",
                        "body": "Are you sure you want to send report to shareholder ?",
                        "message": {
                            "success": "Report sent successfully!",
                        },
                        "button": {
                            "cancel": "Cancel",
                            "confirm": "Confirm",
                        }
                    }
                },
                "message": {
                    "success": "Accounting report has been sent!",
                    "errorSomethingWentWrong": "Something went wrong! Please refresh page and try again!",
                    "errorEmailNotPresent": "Email for shareholder not present!",
                    "errorNoReportAvailable": "No report available for this release."
                }
            }
        }
    }
};

export default accountingEN;